import { useController, useFormContext } from 'react-hook-form'
import { Button, Typography } from '@mui/material'

import VerificationCodeInput from './VerificationCodeInput'

export default function VerifyPage(): JSX.Element {
  const { control, watch } = useFormContext()
  const {
    field,
    fieldState: { error },
  } = useController({
    name: 'otp',
    control,
    rules: {
      required: 'Enter one time password we have send to your email',
    },
  })

  const email = watch('email')

  const codeInputProps = {
    ...field,
    error: error !== undefined,
    helperText: error?.message,
  }

  return (
    <>
      <Typography variant="h4" align="center">
        Please check your inbox
      </Typography>
      <Typography
        variant="body2"
        align="center"
        sx={{
          color: (theme) => theme.palette.text.secondary,
          mb: 2.5,
        }}
      >
        We just sent your one-time passcode to {email}
      </Typography>
      <VerificationCodeInput {...codeInputProps} />
      <Button type="submit" variant="contained">
        Sign In
      </Button>
    </>
  )
}
